module.exports = __webpack_public_path__ + "static/media/photo2.31d496d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/photo2.jpg
// module id = 639
// module chunks = 0